import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import rw from './locales/rw.json';

/**
 * i18next — EN + RW today, French-ready (drop a `fr.json` + register it). Language
 * is detected from the URL/localStorage/navigator and persisted; `escapeValue` off
 * because React already escapes. Keep keys namespaced by feature as the app grows.
 */
export const SUPPORTED_LANGUAGES = ['en', 'rw'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, rw: { translation: rw } },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    detection: { order: ['querystring', 'localStorage', 'navigator'], caches: ['localStorage'] },
  });

export default i18n;
